module.exports = __webpack_public_path__ + "static/media/back-button.8a323959.svg";